import { UserService } from "@/services";

export const operationRoutes = [
  {
    path: "deposit",
    name: "deposit",
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.operations.deposit"
    },
    component: () =>
      import(
        /* webpackChunkName: "deposit" */ "@/components/OperationsPage/Deposit/index"
      )
  },
  {
    path: "withdrawal",
    name: "withdrawal",
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.operations.withdrawal"
    },
    component: () =>
      import(
        /* webpackChunkName: "withdrawal" */ "@/components/OperationsPage/Withdrawal/index"
      )
  },
  {
    path: "exchange",
    name: "exchange",
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.operations.exchange"
    },
    component: () =>
      import(
        /* webpackChunkName: "Exchange" */ "@/components/OperationsPage/Exchange/index"
      )
  },
  {
    path: "transfer",
    name: "transfer",
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.operations.transfer"
    },
    async beforeEnter(to, from, next) {
      UserService.getInfo().then(res => {
        if (res.data.data.is_market_platform_active) {
          next();
        } else {
          next({
            name: "dashboard"
          });
        }
      });
    },
    component: () =>
      import(
        /* webpackChunkName: "Transfer" */ "@/components/OperationsPage/Transfer/index"
      )
  }
];
